import { useState, useEffect, useRef } from 'react';

function generateSessionId() {
	return crypto.randomUUID().replace(/-/g, '').substring(0, 32);
}

export default function useKount(environment) {
	const [sessionId] = useState(() => generateSessionId());
	const [kountReady, setKountReady] = useState(false);
	const [kountError, setKountError] = useState(null);
	const initialized = useRef(false);

	useEffect(() => {
		if (!environment || initialized.current) return;
		initialized.current = true;

		const kountEnv = environment === 'production' ? 'PROD' : 'TEST';

		async function initKount() {
			try {
				const module = await import('../lib/kount-web-client-sdk.js');
				const kountSDKInit = module.default;

				const config = {
					clientID: '654310318262645',
					environment: kountEnv,
					isSinglePageApp: true,
					callbacks: {
						'collect-begin': (params) => {
							console.log('Kount collection started:', params.SessionID);
						},
						'collect-end': (params) => {
							console.log('Kount collection completed:', params.SessionID);
							setKountReady(true);
						}
					}
				};

				const sdk = kountSDKInit(config, sessionId);
				if (!sdk) {
					setKountError('Kount SDK initialization returned null');
				}
			} catch (err) {
				console.error('Kount SDK init error:', err);
				setKountError(err.message);
			}
		}

		initKount();
	}, [environment, sessionId]);

	return { sessionId, kountReady, kountError };
}
